module.exports = __webpack_public_path__ + "static/media/data_pipeline.19430c03.png";